import { render, staticRenderFns } from "./jalan-pesanan.vue?vue&type=template&id=4a5f0a32&"
import script from "./jalan-pesanan.vue?vue&type=script&lang=js&"
export * from "./jalan-pesanan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports